import { useRef } from 'react';
import emailjs from "@emailjs/browser";


function ContactForm() {
	const form = useRef();

	function sendEmail(event) {
		event.preventDefault();

		emailjs.sendForm(
			process.env.REACT_APP_SERVICE_ID,
			process.env.REACT_APP_TEMPLETE_ID,
			form.current,
			process.env.REACT_APP_PRIVATE_KEY
		).then((result) => {
			console.log(result.text);
			window.location.reload(false);
		}).catch((error)=>{
			console.log(error.test);
			window.location.reload(false);
		})
	}

	return (
		<section className="s2">
			<div className="main-container" id="contact-page">
				<h3 style={{ textAlign: "center" }}>Get In Touch</h3>
				<form ref={form} id="contact-form" method="post" onSubmit={sendEmail}>
					<label>Name</label>
					<input className="input-field" type="text" name="user_name" />
					<label>Subject</label>
					<input className="input-field" type="text" name="subject" />
					<label>Email</label>
					<input className="input-field" type="text" name="user_email" />
					<label>Message</label>
					<textarea
						name="message"
						className="input-field"
						cols="30"
						rows="10"
					></textarea>

					<input id="submit-btn" type="submit" value="Send" />
				</form>
			</div>
		</section>
	);
}

export default ContactForm;
